import React from 'react';

import {
  AppTitle,
  LogoText,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
  Paragraph,
  StyledLogo,
  Subtitle,
} from './styles';
import Logo from '../../../../assets/Logo';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';

interface NonCloseableWelcomeModalProps {
  isOpen: boolean;
}

const NonCloseableWelcomeModal: React.FC<NonCloseableWelcomeModalProps> = ({
  isOpen,
}) => {
  const { t } = useI18n();
  const bpNumbers = ['15424874', '54613558'];

  return (
    isOpen && (
      <ModalOverlay>
        <ModalContent>
          <ModalHeader>
            <ModalTitle>
              {t(TranslationKeys.noncloseable_welcomemodal_title)}
            </ModalTitle>
            <StyledLogo>
              <Logo />
              <LogoText>
                <AppTitle>CropConnect</AppTitle>
                <Subtitle>by Nordzucker</Subtitle>
              </LogoText>
            </StyledLogo>
          </ModalHeader>
          <ModalBody>
            <Paragraph>
              {t(TranslationKeys.noncloseable_welcomemodal_paragraph_1)}
            </Paragraph>
            <Paragraph>
              {t(TranslationKeys.noncloseable_welcomemodal_paragraph_2)}
              {bpNumbers.map((bpNumber) => (
                <p>- {bpNumber}</p>
              ))}
            </Paragraph>
            <Paragraph>
              {t(TranslationKeys.noncloseable_welcomemodal_paragraph_3)}
            </Paragraph>
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    )
  );
};

export default NonCloseableWelcomeModal;
